module.exports = __webpack_public_path__ + "static/media/overpass-italic.6a8cb294.eot";